<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'canlianReturn'
}
</script>

<style>

</style>
